module.exports = __webpack_public_path__ + "media/icons/load-more-cars-arrow-0766d4cf.png";